/**
 * index
 * @type {{}}
 */
import Header from '@/components/Header/header.vue'
import Menu from '@/components/Menu/menu.vue'
import { mapMutations } from "vuex";
import { getProcessListService } from "@/service/workflow-service";
import { Message } from "view-design";
import { getDeviceListService } from "@/service/device-info-service";

const Index = {
    name:'Index',
    components:{
        Header,
        Menu
    },
    // 路由进入前钩子（能稳定拿到 from）
    beforeRouteEnter(to, from, next) {
        next(vm => {
            // 判断来源是不是登录页
            if (from.path === '/login') {
                vm.isFromLogin = true
            }
        })
    },
    data() {
        return {
            windowWidth:window.innerWidth, //获取窗口宽度
            isFromLogin:false,
        }
    },
    created() {
    },
    mounted() {
        if(this.isFromLogin){
            this.onProcessList().then()
        }
        window.onresize = () => {
            return (() => {
                if(window.innerWidth < 1200){
                    this.SET_MENU_VISIBLE(false)
                }
            })()
        };
    },
    methods: {
        ...mapMutations('system',['SET_MENU_VISIBLE']),
        /**
         * 获取工作流程列表
         */
        async onProcessList() {
            try {
                this.processLoading = true
                this.processListArray = {}
                let params = {
                    sortType:'',
                    status:'',
                    size:9,
                    page:1
                }
                const { code,data } = await getProcessListService(params)
                if(code === 'SUCCESS'){
                    if(data.totalSize!==0){
                        this.$router.push('/workflow/process/list')
                    }else{
                        this.onDeviceListAll().then()
                    }
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
            }catch (error){
                console.log(error)
            }
        },
        async onDeviceListAll() {
            try {
                this.deviceLoading = true
                this.deviceListArray = {}
                let params = {
                    deviceType:'',
                    manufacturer:'',
                    search:'',
                    displayNumber:10,
                    currentPage:1
                }
                const { code,data } = await getDeviceListService(params)
                if(code === 'SUCCESS'){
                    if(data.totalSize!==0){
                        this.$router.push('/device/list')
                    }else{
                        this.$router.push('/blank/page')
                    }
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.deviceLoading = false
            }catch (error){
                this.deviceLoading = false
                console.log(error)
            }
        },
    },
}
export default Index
